import { Target } from 'framer-motion';
import { TRANSITION_DURATION } from './constants';

/** use function to prevent modify object globally */
export const getFadeAnimation = () => ({
  initial: { opacity: 0 } as Target,
  exit: { opacity: 0 } as Target,
  animate: { opacity: 1 } as Target,
  transition: { duration: TRANSITION_DURATION / 1000 },
});
